import type { FunctionComponent } from 'react'
import { createSlugGenerator } from '@which/shared'

import type { HubPageContentItem, JumpLink } from '../../../../generated/frontend'
import { JumplinksInline } from '../../../../shared/components/JumplinksInline'

export const HubPageJumplinks: FunctionComponent<Props> = ({ contentItems }) => {
  if (!contentItems?.length) {
    return null
  }

  const createSlug = createSlugGenerator()
  const multiLinkCollections = contentItems.filter((e) => e.type === 'multiLinkCollection')

  const links: JumpLink[] = []

  multiLinkCollections.forEach((multiLinkCollection) => {
    const multiLinks = multiLinkCollection.data?.hubMultiLinks.map(({ title }) => ({
      label: title,
      id: createSlug(title),
    }))

    links.push(multiLinks)
  })

  return <JumplinksInline links={links.flat()} />
}

///////// IMPLEMENTATION /////////

type Props = {
  contentItems: HubPageContentItem[]
}
